<template>
  <div class="qualificationApplication">
    <personalHead title="新增测试班" :hide="true" />
    <div class="form">
      <el-form
        :model="ruleForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
        label-width="200px"
        class="demo-ruleForm abcd-class"
      >
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="报 名 时 间" prop="register_time">
              <el-date-picker
                v-model="ruleForm.register_time"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width:100%;"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="测 试 时 间" prop="test_time">
              <el-date-picker
                v-model="ruleForm.test_time"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                style="width:100%;"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="考 点 地 址" prop="test_address">
              <el-select v-model="ruleForm.test_address" placeholder="请选择" style="width:100%;">
                <el-option
                  v-for="item in test_addressList"
                  :key="item.value"
                  :label="(item.province_name == item.city_name ?item.province_name:item.province_name+item.city_name) + item.district_name + item.detailed_address"
                  :value="item.address_value"
                  :disabled="item.disabled"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="测 试 等 级" prop="test_grade">
              <el-select
                v-model="ruleForm.test_grade"
                multiple
                placeholder="请选择测试等级"
                style="width:100%;"
              >
                <el-option
                  v-for="item in test_gradeList"
                  :key="item.grade_value"
                  :label="item.grade_name"
                  :value="item.grade_value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="测试班名称" prop="test_class_title">
              <el-input v-model="ruleForm.test_class_title"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="测试人数上限" prop="testNum">
              <el-input v-model="ruleForm.testNum"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <div class="Assessor">
              <label>一级考评员</label>
              <div class="con">
                <div class="con_right">
                  <p v-if="firstAssessorList">
                    <span v-for="(item,index) in firstAssessorList" :key="index">{{item.name}}</span>
                  </p>
                </div>
                <span class="add" @click="addAssessor(1)">添加</span>
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <div class="Assessor">
              <label>二级考评员</label>
              <div class="con">
                <div class="con_right">
                  <p v-if="secondAssessorList">
                    <span v-for="(item,index) in secondAssessorList" :key="index">{{item.name}}</span>
                  </p>
                </div>
                <span class="add" @click="addAssessor(2)">添加</span>
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <div class="Assessor">
              <label>三级考评员</label>
              <div class="con">
                <div class="con_right">
                  <p v-if="thirdAssessorList">
                    <span v-for="(item,index) in thirdAssessorList" :key="index">{{item.name}}</span>
                  </p>
                </div>
                <span class="add" @click="addAssessor(3)">添加</span>
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <div class="Assessor">
              <label><span style="color: red;">*</span>&nbsp;证书证章邮寄地址</label>
              <div class="con">
                <div class="con_right">
                    <el-row style="width: 100%; margin-left: 0px;">
                      <el-col :xs="8" :sm="8" :md="8" >
                        <el-form-item prop="province" >
                          <el-select
                            v-model="ruleForm.province"
                            placeholder="请选择省"
                            style="margin-left: -200px;"
                            @change="chooseProvince($event)"
                          >
                            <el-option
                              v-for="item in province"
                              :key="item.id"
                              :label="item.area_name"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="8" :sm="8" :md="8" style="padding-left:0px;">
                        <el-form-item prop="city">
                          <el-select
                            v-model="ruleForm.city"
                            placeholder="请选择市"
                            style="margin-left: -200px;"
                            @change="chooseCity($event)"
                          >
                            <el-option
                              v-for="item in city"
                              :key="item.id"
                              :label="item.area_name"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col  :xs="8" :sm="8" :md="8" style="padding-left:0px;">
                        <el-form-item prop="district">
                          <el-select
                            v-model="ruleForm.district"
                            placeholder="请选择地区"
                            style="margin-left: -200px;"
                            @change="chooseDistrict($event)"
                          >
                            <el-option
                              v-for="item in district"
                              :key="item.id"
                              :label="item.area_name"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="详细地址" prop="addressinfo">
              <el-input v-model="ruleForm.addressinfo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="联系人" prop="contact">
              <el-input v-model="ruleForm.contact"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="联系电话" prop="contact_number">
              <el-input v-model="ruleForm.contact_number"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item class="submit">
              <el-button
                type="danger"
                @click="sub('ruleForm')"
                style="width:100px;height:40px"
                :loading="loading"
              >提 交</el-button>
              <el-button type="danger" @click="goReturn" style="width:100px;height:40px" plain>返回</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <el-dialog :title="title" :visible.sync="dialogVisible" :width="dialogWidth" class="visible">
      <el-row :gutter="10" style="border-bottom:1px solid #eee;">
        <el-col :xs="24" :sm="24" :md="18" style="border-right:1px solid #eee;">
          <el-row :gutter="11" style="margin-bottom:10px;" v-if="title=='考评组长' ? false : true ">
            <el-col :xs="8" :sm="6" :md="8">
              <el-select
                v-model="searForm.province"
                placeholder="请选择省"
                @change="chooseProvince($event)"
                size="medium"
                style="width:100%"
              >
                <el-option
                  v-for="item in province"
                  :key="item.id"
                  :label="item.area_name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :xs="8" :sm="6" :md="8">
              <el-select
                v-model="searForm.city"
                placeholder="请选择城市"
                @change="chooseCity($event)"
                size="medium"
                style="width:100%"
              >
                <el-option
                  v-for="item in city"
                  :key="item.id"
                  :label="item.area_name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-col>   
            <el-col :xs="8" :sm="6" :md="8">
              <el-select
                v-model="searForm.district"
                placeholder="请选择地区"
                @change="chooseDistrict($event)"
                size="medium"
                style="width:100%"
              >
                <el-option
                  v-for="item in district"
                  :key="item.id"
                  :label="item.area_name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row :gutter="12" style="margin-bottom:10px;" v-if="title== '考评组长' ? false : true">
            <el-col :xs="8" :sm="8" :md="8">
              <el-input
                v-model="searForm.keyword"
                placeholder="姓名查询"
                size="medium"
                style="width:100%"
              ></el-input>
            </el-col>
            <el-col :xs="16" :sm="16" :md="16">
              <el-button type="primary" icon="el-icon-search" size="medium" @click="searchPerson" style="padding:10px 5px;">搜索</el-button>
              <el-button icon="el-icon-delete" size="medium" @click="clear" style="padding:10px 5px;">清空</el-button>
            </el-col>
          </el-row>
          <el-table :data="tableData" style="width: 100%;min-height:300px" @row-click="addPerson">
            <el-table-column prop="name" label="姓名" align="center"></el-table-column>
            <el-table-column prop="evaluator_rank_name" label="级别" align="center"></el-table-column>
            <el-table-column prop="mobile" label="手机号" align="center"></el-table-column>
          </el-table>
          <el-row :gutter="12" v-if="title== '考评组长' ? false : true">
            <el-col :xs="24" :sm="24" :md="24">
              <div class="pagination" style="margin-top: 10px;text-align: center;">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  :current-page="currentPage"
                  @current-change="handleCurrentChange"
                  :page-size="paging.limit"
                  :total="totalCount"
                  v-if="totalCount>5"
                ></el-pagination>
              </div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :xs="24" :sm="24" :md="6">
          <div style="padding-left:10px;">
            <h3>已选{{title}}</h3>
          </div>
          <ul class="visible_ul" v-if="title=='一级考评员'">
            <li
              v-for="(item,index) in choseFirstAppraiser"
              :key="index"
              class="choseLi"
              @mouseover="showIcon = item"
              @mouseleave="showIcon = ''"
            >
              <span class="name">{{item.name}}</span>
              <i
                :class="item == showIcon?'delet-icon el-icon-close':''"
                @click="remover(item,index)"
              ></i>
            </li>
          </ul>
          <ul class="visible_ul" v-if="title=='二级考评员'">
            <li
              v-for="(item,index) in choseSecondAppraiser"
              :key="index"
              class="choseLi"
              @mouseover="showIcon = item"
              @mouseleave="showIcon = ''"
            >
              <span class="name">{{item.name}}</span>
              <i
                :class="item == showIcon?'delet-icon el-icon-close':''"
                @click="remover(item,index)"
              ></i>
            </li>
          </ul>
          <ul class="visible_ul" v-if="title=='三级考评员'">
            <li
              v-for="(item,index) in choseThirdAppraiser"
              :key="index"
              class="choseLi"
              @mouseover="showIcon = item"
              @mouseleave="showIcon = ''"
            >
              <span class="name">{{item.name}}</span>
              <i
                :class="item == showIcon?'delet-icon el-icon-close':''"
                @click="remover(item,index)"
              ></i>
            </li>
          </ul>
          <ul class="visible_ul" v-if="title=='考评组长'">
            <li
              v-for="(item,index) in choseleaderList"
              :key="index"
              class="choseLi"
              @mouseover="showIcon = item"
              @mouseleave="showIcon = ''"
            >
              <span class="name">{{item.name}}</span>
              <i
                :class="item == showIcon?'delet-icon el-icon-close':''"
                @click="remover(item,index)"
              ></i>
            </li>
          </ul>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="chooseCancle">取 消</el-button>
        <el-button type="primary" @click="chooseComplete">完 成</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { GetUserCoachList, GetDistrictList } from "@/api/admin/common.js";
//import { GetSites, GetGrades, CreateTestApply } from "@/api/admin/test.js";
import { GetSites, GetGrades ,CreateTestApply } from "@/api/admin/test.js";
import personalHead from "@/views/admin/components/personalHead.vue";
import { isMobile, isNumber } from "@/util/validate.js";
var checkPhone = (rule, value, callback) => {
  if (!value) {
    callback(new Error("请输入联系方式"));
  } else {
    if (isMobile(value)) {
      callback();
    } else {
      return callback(new Error("请输入正确的电话"));
    }
  }
};
var checkPeople = (rule, value, callback) => {
  if (!value) {
    callback(new Error("请输入测试人数，为阿拉伯数字"));
  } else {
    if (isNumber(value)) {
      callback();
    } else {
      return callback(new Error("请输入阿拉伯数字"));
    }
  }
};
export default {
  components: {
    personalHead
  },
  data() {
    return {
      ruleForm: {
        grade_one_examiner: [],
        grade_two_examiner: [],
        grade_three_examiner: [],
        // evaluation_team_leader: "",
        test_grade: []
      },
      firstAssessorData: [],
      secondAssessorData: [],
      thirdAssessorData: [],

      firstAssessorList: [],
      secondAssessorList: [],
      thirdAssessorList: [],

      // leaderList: [],
      // leaderListEcho: [],

      rules: {
        province:[
          {
            required: true,
            message: " ",
            trigger: "blur"
          }
        ],
        city:[
          {
            required: true,
            message: "  ",
            trigger: "blur"
          }
        ],   
        district:[
          {
            required: true,
            message: "  ",
            trigger: "blur"
          }
        ],
        register_time: [
          {
            required: true,
            message: "请选择报名时间",
            trigger: "change"
          }
        ],
        test_time: [
          {
            required: true,
            message: "请选择测试时间",
            trigger: "change"
          }
        ],
        test_address: [
          {
            required: true,
            message: "请选择考点地址",
            trigger: "change"
          }
        ],
        test_grade: [
          {
            required: true,
            message: "请选择测试等级",
            trigger: "change"
          }
        ],
        test_class_title: [
          {
            required: true,
            message: "请填写测试班名称",
            trigger: "blur"
          }
        ],
        // testNum: [
        //   {
        //     required: true,
        //     message: "请填写测试班人数",
        //     trigger: "blur"
        //   }
        // ],
        contact: [
          {
            required: true,
            message: "请填写联系人",
            trigger: "blur"
          }
        ],
        
        addressinfo:[
          {
            required: true,
            message: "请填写详细地址",
            trigger: "blur"
          }
        ],
        testNum: [{ required: true, validator: checkPeople, trigger: "blur" }],
        contact_number: [
          { required: true, validator: checkPhone, trigger: "blur" }
        ]
      },
      test_addressList: [],
      test_gradeList: [],
      dialogVisible: false,
      title: "",
      tableData: [],
      province: [],
      city: [],
      district: [],
      searForm: {},

      choseFirstAppraiser: [],
      choseSecondAppraiser: [],
      choseThirdAppraiser: [],
      choseleaderList: [],
      showIcon: "",
      paging: {
        limit: 5,
        page: 1
      },
      evaluator_rank: {},
      totalCount: 0,
      loading: false,
      currentPage: 1,
      dialogWidth: "60%",
      screenWidth: document.body.clientWidth
    };
  },
  watch: {
    "searForm.province"(val) {
      
      GetDistrictList({ parent_id: val }).then(data => {
        this.city = data.data.result.items;
        this.searForm.city = this.city[0].id;
        this.chooseCity(this.searForm.city);
      });
    },
    screenWidth(val) {
      this.screenWidth = val;
      if (this.screenWidth < 769) {
        this.dialogWidth = "90%";
      } else {
        this.dialogWidth = "60%";
      }
    }
  },
  created() {
    this.getList();
    if (this.screenWidth < 768) {
      this.dialogWidth = "90%";
    }
  },
  mounted() {
    const that = this;
    this.$nextTick(() => {
      window.onresize = () => {
        return (() => {
          window.screenWidth = document.body.clientWidth;
          that.screenWidth = window.screenWidth;
        })();
      };
    });
  },
  methods: {
    getList() {
      GetSites({}).then(data => {
        var list = data.data.result;
        if (list) {
          this.test_addressList = list.items;
        }
      });
      GetGrades({}).then(data => {
        var list = data.data.result;
        if (list) {
          this.test_gradeList = list.items;
        }
      });
      this.getDistrictList();
    },
    sub(ruleForm) {
      
      //debugger
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          var levelArr = this.ruleForm.test_grade;
          
          if (levelArr.length == 1) {
            var num = levelArr[0];
            if (5 < num && num < 10) {
              this.adultCompare(num);
            } else {
              this.childrenCompare(num);
            }
          } else {
            var levelMin = Math.min(...levelArr);
            if (5 < levelMin && levelMin < 10) {
              this.adultCompare(levelMin);
            } else if(9<levelMin && levelMin<14){
              this.adultCompare(levelMin);
            } else {
              this.childrenCompare(levelMin);
            }
          }
        } else {
          return false;
        }
      });
    },
    //  成人考评员验证
    adultCompare(levelMin) {
      
      
      if (levelMin == 9 ||levelMin == 10 ||levelMin == 11 ||levelMin == 12 ||levelMin == 13  ) {
        if (this.ruleForm.grade_one_examiner.length < 1) {
          this.$message.error("至少选择一个一级考评员");
        } else {
          this.allAdultCompare(this.ruleForm.grade_one_examiner.length);
        }
      } else if (levelMin == 8 || levelMin == 7 || levelMin == 6 ) {
        if (this.ruleForm.grade_one_examiner.length < 2) {
          this.$message.error("至少选择两个一级考评员");
        } else {
          this.allAdultCompare(this.ruleForm.grade_one_examiner.length);
        }
      }  else {
        if (this.ruleForm.grade_one_examiner.length < 3) {
          this.$message.error("至少选择三个一级考评员");
        } else {
          this.allAdultCompare(this.ruleForm.grade_one_examiner.length);
        }
      }
    },
    //  成人总数比较
    allAdultCompare(num) {
      
      let count =
        num +
        this.ruleForm.grade_two_examiner.length +
        this.ruleForm.grade_three_examiner.length;
        /*
      if (count < 4) {
        this.$message.error("至少选择4个考评员");
      } else {
        this.leaderCompare();
      }
      */
     this.leaderCompare();
    },
    //  儿童考评员验证
    childrenCompare(levelMin) {
      
      if (levelMin == 10 ||levelMin == 11 ||levelMin == 12 || levelMin == 13  ) {
        if (this.ruleForm.grade_one_examiner.length < 1) {
          this.$message.error("至少选择一个一级考评员");
        } else {
          this.allAdultCompare(this.ruleForm.grade_one_examiner.length);
        }
      }else if(levelMin == 14 ||levelMin == 15 ||levelMin == 16){
        if((this.ruleForm.grade_one_examiner.length  + this.ruleForm.grade_two_examiner.length  ) < 1){
          this.$message.error("至少选择一个二级以上考评员");
        }else {
          this.allAdultCompare(this.ruleForm.grade_one_examiner.length);
        }
      }
      /*
      else if(){
        
      }
      */
      /*
      if (this.ruleForm.grade_two_examiner.length < 1) {
        this.$message.error("至少选择一个二级考评员");
      } else {
        this.allchildrenCompare(this.ruleForm.grade_two_examiner.length);
      }
      */
    },
    //  儿童总数比较
    allchildrenCompare(num) {
      
      let count =
        num +
        this.ruleForm.grade_one_examiner.length +
        this.ruleForm.grade_three_examiner.length;
        /*
      if (count < 4) {
        this.$message.error("至少选择4个考评员");
      } else {
        this.leaderCompare();
      }
      */
      this.leaderCompare();
    },
    //组长验证
    leaderCompare() {
      // if (this.ruleForm.evaluation_team_leader == "") {
      //   this.$message.error("至少选择一个考评组长");
      // } else {
        //全部验证完成，提交数据
        
        if(this.ruleForm.city == undefined){
            window.alert("请填写地址");
            return false;
        }else{
          if(this.ruleForm.addressinfo == undefined){
            
            window.alert("请填写详细地址");
            return false;
          }else{
            this.ruleForm.mailing_address = this.ruleForm.province+"_"+this.ruleForm.city+"_"+this.ruleForm.district+"_"+this.ruleForm.addressinfo;
          }
          
        }
        
        //提交代码  2020年9月14日 13:12:26  XXL
        
        
        //上线解开
        
        this.loading = true;
        CreateTestApply(Object.assign(this.ruleForm)).then(data => {
          var list = data.data.result;
          if (list) {
            if (list.isSuccess) {
              this.loading = false;
              this.$message({
                message: "新增测试班成功",
                type: "success"
              });
              this.$router.go(-1);
            } else {
              this.loading = false;
              this.$message.error("新增测试班失败");
            }
          }
        });
        
        //上线解开
        
        
        
        
        
      // }
    },
    addAssessor(i) {
      this.dialogVisible = true;
      this.getDistrictList();
      switch (i) {
        case 1:
          this.title = "一级考评员";
          this.firstData(1);
          break;
        case 2:
          this.title = "二级考评员";
          this.firstData(2);
          break;
        case 3:
          this.title = "三级考评员";
          this.firstData(3);
          break;
        // case 4:
        //   this.title = "考评组长";
        //   this.getLeaderList();
        //   break;
      }
    },
    // 考评员表格数据
    firstData(i) {
      this.evaluator_rank.evaluator_rank = i;
      this.paging = {
        limit: 5,
        page: 1
      };
      this.currentPage = 1;
      GetUserCoachList(Object.assign(this.paging, this.evaluator_rank)).then(
        data => {
          let list = data.data.result;
          if (list) {
            this.tableData = list.items;
            
            this.totalCount = list.totalCount;
          }
        }
      );
    },
    getDistrictList() {
      
      // 区域列表
      GetDistrictList({ parent_id: "-1" }).then(data => {
        if (data.data.result) {
          this.province = data.data.result.items;
        }
      });
    },
    chooseProvince(item) {
      
      GetDistrictList({ parent_id: item }).then(data => {
        this.city = data.data.result.items;
        
        this.ruleForm.city = this.city[0].id;//"请选择市";
        this.chooseCity(this.city[0].id);
        // this.ruleForm.district = "请选择地区";
      });
    },
    chooseCity(item) {
      
      GetDistrictList({ parent_id: item }).then(data => {
        
        this.district = data.data.result.items;
        this.ruleForm.district = this.district[0].id;
        //this.searForm.district = this.district[0].id;
        
        // this.ruleForm.district = "请选择地区";
      });
    },
    chooseDistrict() {
      this.$forceUpdate();
    },
    //  搜索
    searchPerson() {
      this.searForm.ProvinceId = this.searForm.province;
      this.searForm.CityId = this.searForm.city;
      this.searForm.DistrictId = this.searForm.DistrictId;
      GetUserCoachList(Object.assign(this.paging, this.searForm)).then(data => {
        let list = data.data.result;
        if (list) {
          this.tableData = list.items;
          this.totalCount = list.totalCount;
        }
      });
    },
    clear() {
      this.searForm = {};
      this.paging = {
        limit: 5,
        page: 1
      };
      this.district = [];
      if (this.title == "一级考评员") this.firstData(1);
      else if (this.title == "二级考评员") this.firstData(2);
      else if (this.title == "三级考评员") this.firstData(3);
    },
    addPerson(row) {
      if (this.title == "一级考评员") {
        let result = this.choseFirstAppraiser.some(item => {
          if (item.id == row.id) {
            return true;
          }
        });
        if (result) {
          // 如果存在
          this.$message({
            message: "已经选择了" + row.name,
            type: "warning"
          });
        } else {
          this.choseFirstAppraiser.push(row);
          // this.leaderList.push(row);
        }
      } else if (this.title == "二级考评员") {
        let result = this.choseSecondAppraiser.some(item => {
          if (item.id == row.id) {
            return true;
          }
        });
        if (result) {
          // 如果存在
          this.$message({
            message: "已经选择了" + row.name,
            type: "warning"
          });
        } else {
          this.choseSecondAppraiser.push(row);
          // this.leaderList.push(row);
        }
      } 
      else {
        let result = this.choseThirdAppraiser.some(item => {
          if (item.id == row.id) {
            return true;
          }
        });
        if (result) {
          // 如果存在
          this.$message({
            message: "已经选择了" + row.name,
            type: "warning"
          });
        } else {
          this.choseThirdAppraiser.push(row);
          // this.leaderList.push(row);
        }
      }
      //  else {
      //   if (this.choseleaderList.length == 1) {
      //     this.$message.error("只能选择一个考评组长");
      //   } else {
      //     this.choseleaderList.push(row);
      //   }
      // }
    },
    //考评员列表分页
    handleCurrentChange(cpage) {
      this.paging.page = cpage;
      this.currentPage = cpage;
      if (this.title == "一级考评员") {
        GetUserCoachList(Object.assign(this.paging, this.appraiser_grade)).then(
          data => {
            var list = data.data.result;
            if (list) {
              this.tableData = list.items;
            }
          }
        );
      }
      if (this.title == "二级考评员") {
        GetUserCoachList(Object.assign(this.paging, this.appraiser_grade)).then(
          data => {
            var list = data.data.result;
            if (list) {
              this.tableData = list.items;
            }
          }
        );
      }
      if (this.title == "三级考评员") {
        GetUserCoachList(Object.assign(this.paging, this.appraiser_grade)).then(
          data => {
            var list = data.data.result;
            if (list) {
              this.tableData = list.items;
            }
          }
        );
      }
    },
    chooseComplete() {
      this.dialogVisible = false;
      if (this.title == "一级考评员") {
        this.firstAssessorList = this.choseFirstAppraiser;
        this.grade_one_examiner = [];
        for (let i = 0; i < this.firstAssessorList.length; i++) {
          this.grade_one_examiner.push(this.firstAssessorList[i].id);
        }
        this.ruleForm.grade_one_examiner = this.grade_one_examiner;
      } else if (this.title == "二级考评员") {
        this.secondAssessorList = this.choseSecondAppraiser;
        this.grade_two_examiner = [];
        for (let i = 0; i < this.secondAssessorList.length; i++) {
          this.grade_two_examiner.push(this.secondAssessorList[i].id);
        }
        this.ruleForm.grade_two_examiner = this.grade_two_examiner;
      } else {
        this.thirdAssessorList = this.choseThirdAppraiser;
        this.grade_three_examiner = [];
        for (let i = 0; i < this.thirdAssessorList.length; i++) {
          this.grade_three_examiner.push(this.thirdAssessorList[i].id);
        }
        this.ruleForm.grade_three_examiner = this.grade_three_examiner;
      } 
      // else {
      //   this.leaderListEcho = this.choseleaderList;
      //   this.evaluation_team_leader = this.leaderListEcho[0].id;
      //   this.ruleForm.evaluation_team_leader = this.evaluation_team_leader;
      // }
    },
    // 考评组长数据
    // getLeaderList() {
    //   this.tableData = this.leaderList;
    // },
    chooseCancle() {
      this.dialogVisible = false;
      this.searForm = {};
      // this.choseAppraiser={}
      // this.firstAssessorList={};
      // this.ruleForm.firstAssessor=[];
    },
    remover(item, index) {
      if (this.title == "一级考评员") {
        this.choseFirstAppraiser.splice(index, 1);
        // this.deleteLeader(item);
      } else if (this.title == "二级考评员") {
        this.choseSecondAppraiser.splice(index, 1);
        // this.deleteLeader(item);
      } else{
        this.choseThirdAppraiser.splice(index, 1);
        // this.deleteLeader(item);
      } 
      // else {
      //   this.choseleaderList.splice(index, 1);
      // }
    },
    // deleteLeader(item) {
    //   for (let i = 0; i < this.leaderList.length; i++) {
    //     if (this.leaderList[i].id == item.id) this.leaderList.splice(i, 1);
    //   }
    //   if (this.choseleaderList[0].id == item.id)
    //     this.choseleaderList.splice(0, 1);
    // },
    goReturn() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="less">
.qualificationApplication {
  .form {
    width: 70%;
    .Assessor {
      overflow: hidden;
      padding-bottom: 20px;
      label {
        float: left;
        display: block;
        width: 200px;
        text-align: right;
        color: #606266;
        line-height: 40px;
        padding-right: 42px;
        font-size: 14px;
        font-weight: 400;
        box-sizing: border-box;
      }
      @media screen and (max-width: 767px) {
        label {
          width: 121px;
          float: none;
        }
      }
      .con {
        line-height: 40px;
        position: relative;
        font-size: 14px;
        margin-left: 200px;
        .con_right {
          p {
            width: 100%;
            height: 40px;
            background-color: #f5f7fa;
            color: #c0c4cc;
            line-height: 40px;
            padding: 6px 15px;
            border-radius: 4px;
            border: 1px solid #dcdfe6;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            overflow: hidden;
            margin-bottom: 5px;
            span {
              font-size: 12px;
              border: 1px solid #e9e9eb;
              border-radius: 4px;
              background-color: #f4f4f5;
              color: #909399;
              height: 24px;
              padding: 0 8px;
              line-height: 22px;
              display: block;
              float: left;
              margin-right: 5px;
            }
          }
          .add {
            color: #f56c6c;
            cursor: pointer;
            // font-size:14px !important;
          }
        }
      }
      @media screen and (max-width: 767px) {
        .con {
          margin-left: 0;
        }
      }
    }
    .el-form-item__label {
      padding-right: 42px;
      font-size: 14px;
      font-weight: 400;
    }
    .submit {
      text-align: center;
      .el-form-item__content {
        margin-left: 0px !important;
      }
    }
  }
  .visible {
    .visible_ul {
      height: 400px;
      overflow-x: hidden;
      overflow-y: scroll;
      .choseLi {
        position: relative;
        margin: 10px 0px;
        padding: 0px 10px;
        font-size: 16px;
        display: flex;
        .name {
          display: inline-block;
          padding: 7px;
        }
        .delet-icon {
          border-radius: 50%;
          background: #aaa;
          color: #fff;
          position: absolute;
          right: 10px;
          top: 50%;
          margin-top: -7px;
        }
      }
      .choseLi:hover {
        background: #eee;
        border-radius: 10px;
      }
    }
    @media screen and(max-width:767px){
      .visible_ul{
        height: 100px !important;
      }
    }
    .visible_ul::-webkit-scrollbar {
      display: none;
    }
    .pagination {
      text-align: center;
      margin: 30px 0px 10px 0px;
    }
  }
}
.abcd-class{
  width: 900px;
}
</style>


